import { TARA_MODULE_LABELS } from './classifyTaraPaperModule';

export function buildTaraTopicOverviewRows({
  moduleKey,
  questionCount,
  timed,
  durationMinutes,
} = {}) {
  const count = Number(questionCount) || 0;
  const label = TARA_MODULE_LABELS[moduleKey] || 'Practice';
  return [{
    section: label,
    questions: count,
    time: timed ? `${durationMinutes} minutes` : 'Untimed',
  }];
}

export function buildTaraTopicOverviewBodyCopy({
  moduleKey,
  questionCount,
  timed,
  durationMinutes,
} = {}) {
  const count = Number(questionCount) || 0;
  const label = TARA_MODULE_LABELS[moduleKey] || 'this module';
  return [{
    text: `This practice consists of one module: ${label}. There are ${count} questions${timed ? ` and ${durationMinutes} minutes` : ' and it is untimed'}.`,
  }];
}
